export const SIDEBAR_PERSISTENT_CLOSE_KEY = 'sidebarPersistentClose';
export const PINNED_COMPANIES_KEY = 'pinnedCompanies';
